import React from 'react';

const PortfolioNav = () => {
  return (
    <nav id="nav" className="portfolio-nav">
      <a href="#hero" className="nav-logo">Bill Bolte</a>
      <ul className="nav-links">
        <li><a href="#about">About</a></li>
        <li><a href="#skills">Skills</a></li>
        <li><a href="#resume">Resume</a></li>
        <li><a href="#recommendations">Recommendations</a></li>
        <li><a href="#contact">Contact</a></li>
        <li><a href="#diligence">Diligence</a></li>
      </ul>
    </nav>
  );
};

export default PortfolioNav;

